import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { RowColumnsGuttersTitle } from "../../../Constants/Constants";
import { RowColumnsGuttersSubTitle } from "../../../Data/UiKits/Grid";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const RowColumnsGutters = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={RowColumnsGuttersTitle} span={RowColumnsGuttersSubTitle} />
        <CardBody className="r-c-gutter">
          <Container className="text-center">
            <Row className="row-cols-2 row-cols-xxl-5 row-cols-xl-4 row-cols-md-3 g-2 g-lg-3">
              {dynamicNumber(10).map((item, index) => (
                <Col>
                  <div className="p-10">
                    <span>Row column</span>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RowColumnsGutters;
